export default __webpack_public_path__ + "static/media/07-insight-group.df257912.png";